import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const long_term_tool = apiUrl + "/long_term_tool";
const routes = {
  label: "Long Term Tool",
  new: long_term_tool + "/new",

  update_ltt_by_supply_chain: long_term_tool + "/update_ltt_by_supply_chain",
  update_ltt_by_corporate: long_term_tool + "/update_ltt_by_corporate",
  update_ltt_by_structure: long_term_tool + "/update_ltt_by_structure",

  get_by_supply_chain_id: long_term_tool + "/get_by_supply_chain_id",
  get_by_corporate_id: long_term_tool + "/get_by_corporate_id",
  get_by_structure_id: long_term_tool + "/get_by_structure_id",
};

export const LongTermTool = {
  label: routes.label,
  new: (long_term_tool) => postWithToken(routes.new, long_term_tool),

  update_ltt_by_supply_chain: (long_term_tool) => postWithToken(routes.update_ltt_by_supply_chain, long_term_tool),
  update_ltt_by_corporate: (long_term_tool) => postWithToken(routes.update_ltt_by_corporate, long_term_tool),
  update_ltt_by_structure: (long_term_tool) => postWithToken(routes.update_ltt_by_structure, long_term_tool),

  get_by_supply_chain_id: (supply_chain_id) => postWithToken(routes.get_by_supply_chain_id, { supply_chain_id }),
  get_by_corporate_id: (corporate_id) => postWithToken(routes.get_by_corporate_id, { corporate_id }),
  get_by_structure_id: (structure_id) => postWithToken(routes.get_by_structure_id, { structure_id }),
};
